import { createRouter, createWebHistory } from 'vue-router'

// Importa todos los componentes necesarios
import HomeView from '../views/HomeView.vue'
import RegisterUserView from '../views/RegisterUserView.vue'
import FamiliesView from '../views/FamiliesView.vue'
import FormsByFamilyView from '../views/FormsByFamilyView.vue'
import CompleteSectionSheetView from '../views/Client/Sheet/CompleteSectionSheetView.vue'
import CompleteSectionProfileView from '../views/Client/Profile/CompleteSectionProfileView.vue'
import CompleteSectionTubeView from '../views/Client/Tube/CompleteSectionTubeView.vue'
import ActualQuoteView from '../views/ActualQuoteView.vue'
import SheetImgQuoteView from '../views/Client/Sheet/SheetImgQuoteView.vue'
import SheetNoImgQuoteView from '../views/Client/Sheet/SheetNoImgQuoteView.vue'
import ProfileFamilyView from '../views/Client/Profile/ProfileFamilyView.vue'
import ProfileQuoteView from '../views/Client/Profile/ProfileQuoteView.vue'
import TubeFamilyView from '../views/Client/Tube/TubeFamilyView.vue'
import TubeQuoteView from '../views/Client/Tube/TubeQuoteView.vue'
import HomeAdminView from '../views/Admin/HomeAdminView.vue'
import SheetCatalogueAdminView from '../views/Admin/Sheet/SheetCatalogueAdminView.vue'
import NewSheetFormAdminView from '../views/Admin/Sheet/NewSheetFormAdminView.vue'
import SheetImagesAdminView from '../views/Admin/Sheet/SheetImagesAdminView.vue'
import NewSheetImgAdminView from '../views/Admin/Sheet/NewSheetImgAdminView.vue'
import ProfileCatalogueAdminView from '../views/Admin/Profile/ProfileCatalogueAdminView.vue'
import NewProfileFormAdminView from '../views/Admin/Profile/NewProfileFormAdminView.vue'
import ProfileImagesAdminView from '../views/Admin/Profile/ProfileImagesAdminView.vue'
import NewProfileImgFormAdminView from '../views/Admin/Profile/NewProfileImgFormAdminView.vue'
import TubeCatalogueAdminView from '../views/Admin/Tube/TubeCatalogueAdminView.vue'
import NewTubeFormAdminView from '../views/Admin/Tube/NewTubeFormAdminView.vue'
import TubeImagesAdminView from '../views/Admin/Tube/TubeImagesAdminView.vue'
import NewTubeImgAdminView from '../views/Admin/Tube/NewTubeImgAdminView.vue'
import PricesListAdminView from '../views/Admin/Vars/PricesListAdminView.vue'
import RawMatVarsListAdminView from '../views/Admin/Vars/RawMat&VarsListAdminView.vue'
import CompleteSectionsView from '../views/Admin/Vars/CompleteSectionsView.vue'
import ImageFormFamiliesView from '../views/Admin/Vars/ImageFormFamiliesView.vue'

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes:
    [
      {
        path: '/',
        name: 'home',
        component: HomeView
      },
      {
        path: '/RegisterUser',
        name: 'registerUser',
        component: RegisterUserView
      },
      {
        path: '/Families',
        name: 'families',
        component: FamiliesView
      },
      {
        path: '/FamilyForms',
        name: 'FamilyForms',
        component: FormsByFamilyView
      },
      {
        path: '/CompleteSheetSection',
        name: 'CompleteSheetSection',
        component: CompleteSectionSheetView
      },
      {
        path: '/CompleteProfileSection',
        name: 'CompleteProfileSection',
        component: CompleteSectionProfileView
      },
      {
        path: '/CompleteTubeSection',
        name: 'CompleteTubeSection',
        component: CompleteSectionTubeView
      },
      {
        path: '/ActualQuote',
        name: 'actualQuote',
        component: ActualQuoteView
      },
      {
        path: '/SheetImgQuote',
        name: 'sheetImgQuote',
        component: SheetImgQuoteView
      },
      {
        path: '/SheetNoImgQuote',
        name: 'sheetNoImgQuote',
        component: SheetNoImgQuoteView
      },
      {
        path: '/ProfileFamily',
        name: 'profilefamily',
        component: ProfileFamilyView
      },
      {
        path: '/ProfileQuote',
        name: 'profileQuote',
        component: ProfileQuoteView
      },
      {
        path: '/TubeFamily',
        name: 'tubefamily',
        component: TubeFamilyView
      },
      {
        path: '/TubeQuote',
        name: 'tubeQuote',
        component: TubeQuoteView
      },
      {
        path: '/Admin/Home',
        name: 'adminHome',
        component: HomeAdminView
      },
      {
        path: '/Admin/SheetCatalogue',
        name: 'adminSheetCatalogue',
        component: SheetCatalogueAdminView
      },
      {
        path: '/Admin/SheetNew',
        name: 'adminSheetNew',
        component: NewSheetFormAdminView
      },
      {
        path: '/Admin/SheetImages',
        name: 'adminSheetImages',
        component: SheetImagesAdminView
      },
      {
        path: '/Admin/SheetNewImg',
        name: 'adminSheetNewImg',
        component: NewSheetImgAdminView
      },
      {
        path: '/Admin/ProfileCatalogue',
        name: 'adminProfileCatalogue',
        component: ProfileCatalogueAdminView
      },
      {
        path: '/Admin/ProfileNew',
        name: 'adminProfileNew',
        component: NewProfileFormAdminView
      },
      {
        path: '/Admin/ProfileImages',
        name: 'adminProfileImages',
        component: ProfileImagesAdminView
      },
      {
        path: '/Admin/ProfileNewImg',
        name: 'adminProfileNewImg',
        component: NewProfileImgFormAdminView
      },
      {
        path: '/Admin/TubeCatalogue',
        name: 'adminTubeCatalogue',
        component: TubeCatalogueAdminView
      },
      {
        path: '/Admin/TubeNew',
        name: 'adminTubeNew',
        component: NewTubeFormAdminView
      },
      {
        path: '/Admin/TubeImages',
        name: 'adminTubeImages',
        component: TubeImagesAdminView
      },
      {
        path: '/Admin/TubeNewImg',
        name: 'adminTubeeNewImg',
        component: NewTubeImgAdminView
      },
      {
        path: '/Admin/ListPrices',
        name: 'adminListPrices',
        component: PricesListAdminView
      },
      {
        path: '/Admin/ListRMts&Vars',
        name: 'adminListRMts&Vars',
        component: RawMatVarsListAdminView
      },
      {
        path: '/Admin/ListCompSections',
        name: 'adminListCompSections',
        component: CompleteSectionsView
      },
      {
        path: '/Admin/ListImgFormFamilies',
        name: 'adminListImgFormFamilies',
        component: ImageFormFamiliesView
      }
    ],
  base: '/'
})

export default router
